import React from 'react'
import { useHistory } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'
import { useMatchBreakpoints, Flex, Button } from 'penguinfinance-uikit2'

const EmperorBanner = () => {
  const theme = useTheme()
  const { isXl } = useMatchBreakpoints()
  const isMobile = !isXl
  const history = useHistory();

  const handleReadMore = () => {
    history.push('/arena');
  };

  return (
    <SliderContainer>
      <ArenaExpansionContainer>
        <ExpansionImg src={`${process.env.PUBLIC_URL}/images/home-v2/arena/arena_logo.png`} alt='expansion' />
        <UnderDevelopment>Under Development</UnderDevelopment>
        <ReadMoreButton onClick={handleReadMore}>Read More</ReadMoreButton>
      </ArenaExpansionContainer>
      <BannerImagesWrapper>
        <ArenaPuffyImg1 src={`${process.env.PUBLIC_URL}/images/home-v2/arena/puffy1.png`} />
        <ArenaPuffyImg2 src={`${process.env.PUBLIC_URL}/images/home-v2/arena/puffy2.png`} />
        <VSImg src={`${process.env.PUBLIC_URL}/images/home-v2/arena/vs.png`} />
        <BossImg src={`${process.env.PUBLIC_URL}/images/home-v2/arena/boss.png`} />
      </BannerImagesWrapper>
      {!isMobile && <BgImage src={`${process.env.PUBLIC_URL}/images/home-v2/slider-images/penguinfinance/${theme.isDark ? 'dark_bg' : 'light_bg'}.png`} />}
    </SliderContainer>
  )
}

const SliderContainer = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  padding-bottom: 32px;
  height: 256px;
  background-color: ${({ theme }) => (theme.isDark ? '#483692' : '#EE3E40')};
  flex-direction: column;
  align-items: center;

  @media (min-width: 640px) {
    height: 300px;
  }
  @media (min-width: 768px) {
    height: 300px;
  }
  @media (min-width: 968px) {
    padding-bottom: 0;
    height: 280px;
    flex-direction: row;
    align-items: unset;
    justify-content: center;
  }
  @media (min-width: 1200px) {
    height: 340px;
  }
  @media (min-width: 1400px) {
    height: 360px;
  }
`

const BgImage = styled.img`
  position: absolute;
  bottom: 0px;
  width: 100%;
`

const ArenaExpansionContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  z-index: 3;

  @media (min-width: 968px) {
    padding-left: 16px;
    align-items: flex-end;
    z-index: 1;
  }
`;

const ExpansionImg = styled.img`
  position: relative;
  z-index: 2;
  width: 200px;

  @media (min-width: 640px) {
    width: 240px;
  }
  @media (min-width: 968px) {
    width: 240px;
  }
  @media (min-width: 1200px) {
    width: 280px;
  }
  @media (min-width: 1400px) {
    width: 300px;
  }
`;

const UnderDevelopment = styled.div`
  background: #7A5FCF;
  color: white;
  font-weight 800;
  font-size: 14px;
  padding: 10px 16px;
  border-radius: 10px;
  position: relative;
  z-index: 1;
  margin-top: -10px;

  @media (min-width: 640px) {
    font-size: 16px;
    padding: 14px 18px;
    margin-right: 0;
    margin-top: -12px;
  }
  @media (min-width: 968px) {
    font-size: 18px;
    padding: 12px 16px;
    margin-top: -16px;
    margin-right: -16px;
  }
  @media (min-width: 1200px) {
    font-size: 20px;
    padding: 14px 18px;
    margin-top: -16px;
    margin-right: -16px;
  }
  @media (min-width: 1400px) {
    font-size: 24px;
    padding: 16px 24px;
    margin-top: -24px;
    margin-right: -32px;
  }
`;

const ReadMoreButton = styled(Button)`
  background: #EE3E40;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.48);
  border-radius: 7px;
  font-weight: 800;
  color: white;
  font-size: 14px;
  text-decoration: underline;
  position: relative;
  z-index: 1;
  height: 30px;
  margin-right: 8px;
  margin-top: -4px;

  @media (min-width: 640px) {
    height: 32px;
    margin-top: -4px;
    font-size: 16px;
  }
  @media (min-width: 968px) {
    height: 32px;
    font-size: 16px;
  }
  @media (min-width: 1400px) {
    height: 40px;
    font-size: 22px
  }

  &:hover {
    opacity: 1 !important;
  }
`;

const ArenaPuffyImg1 = styled.img`
  position: absolute;
  left: 0;
  z-index: 1;
  width: 120px;
  left: -10px;
  bottom: 0px;

  @media (min-width: 640px) {
    width: 160px;
    left: -10px;
    bottom: -10px;
  }
  @media (min-width: 968px) {
    width: 220px;
    left: -10px;
    bottom: -10px;
  }
  @media (min-width: 1200px) {
    width: 280px;
    left: -14px;
    bottom: -10px;
  }
  @media (min-width: 1400px) {
    width: 280px;
    left: -10px;
    bottom: -20px;
  }
`;

const ArenaPuffyImg2 = styled.img`
  position: absolute;
  z-index: 1;
  width: 140px;
  left: 0px;
  bottom: 40px;

  @media (min-width: 640px) {
    width: 240px;
    left: 30px;
    bottom: -10px;
  }
  @media (min-width: 968px) {
    width: 320px;
    left: 40px;
    bottom: -10px;
  }
  @media (min-width: 1200px) {
    width: 400px;
    left: 70px;
    bottom: -20px;
  }
  @media (min-width: 1400px) {
    width: 420px;
    left: 70px;
    bottom: -20px;
  }
`;

const BossImg = styled.img`
  position: absolute;
  width: 240px;
  right: -72px;
  bottom: 0px;

  @media (min-width: 640px) {
    width: 280px;
    right: 0;
    bottom: 0px;
  }
  @media (min-width: 968px) {
    width: 420px;
    right: -16px;
    bottom: -10px;
  }
  @media (min-width: 1200px) {
    width: 510px;
    right: 0;
    bottom: -10px;
  }
  @media (min-width: 1400px) {
    width: 540px;
    right: 0;
    bottom: -10px;
  }
`;

const VSImg = styled.img`
  position: absolute;
  display: none;
  @media (min-width: 640px) {
    display: none;
    width: 120px;
    left: 50%;
    transform: translate(-100%, 0);
    bottom: -40px;
  }
  @media (min-width: 968px) {
    display: block;
    width: 200px;
    left: 50%;
    transform: translate(-60%, 0);
    bottom: -50px;
  }
  @media (min-width: 1200px) {
    width: 240px;
    left: 50%;
    transform: translate(-60%, 0);
    bottom: -56px;
  }
  @media (min-width: 1400px) {
    width: 240px;
    left: 50%;
    transform: translate(-60%, 0);
    bottom: -48px;
  }
`;

const BannerImagesWrapper = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 440px;
  height: 100%;
  position: absolute;

  @media (min-width: 640px) {
    width: 100%;
    max-width: unset;
  }
  @media (min-width: 768px) {
    width: 720px;
  }
  @media (min-width: 968px) {
    position: relative;
    width: 740px;
  }
  @media (min-width: 1200px) {
    width: 1100px;
  }
  @media (min-width: 1400px) {
    width: 1200px;
  }
  @media (min-width: 1600px) {
    width: 1200px;
  }
`;

export default EmperorBanner
